const styles = {
  clubLogo: {
    width: 46,
    height: 46,
  },
  wrappedClubName: {
    maxWidth: 250,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
    whiteSpace: "nowrap",
  },
  fieldPhoto: {
    width: 60,
    height: 40,
    objectFit: "cover",
    borderRadius: 4,
    cursor: "pointer",
  },
  dialogContent: {
    position: "relative",
    p: 4,
  },
  closeIcon: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  imgDialog: {
    width: "100%",
    height: "auto",
    maxHeight: "85vh",
    objectFit: "cover",
    borderRadius: 8,
  },
};

export default styles;
